<template>
  <span>
    <home-hero></home-hero>
    <home-parallex></home-parallex>
    <home-details></home-details>
    <!-- <home-body></home-body> -->
    <!-- <home-module></home-module> -->
    <page-footer></page-footer>
  </span>
</template>
<script>
import HomeHero from "@/components/HomeHero";
// import HomeBody from '@/components/HomeBody';
import HomeDetails from "@/components/HomeDetails";
// import HomeModule from '@/components/HomeModule';
import HomeParallex from "@/components/HomeParallex";
import PageFooter from "@/components/PageFooter";

export default {
  name: "home",
  components: {
    HomeHero,
    HomeDetails,
    HomeParallex,
    // HomeModule,
    // HomeBody,
    PageFooter,
  },
};
</script>
<style>
html {
  scroll-behavior: smooth;
}
</style>


